export const ASYNC_STATUS = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  PENDING: "PENDING",
  SUCCEEDED: "SUCCEEDED",
  ERROR: "ERROR",
});
